import {
  REPORT_COLUMNS_LIBRARY_REQUEST,
  REPORT_COLUMNS_LIBRARY_SUCCESS,
  REPORT_COLUMNS_LIBRARY_FALIURE,
  REPORT_COLUMNS_REQUEST,
  REPORT_COLUMNS_SUCCESS,
  REPORT_COLUMNS_FALIURE,
  UPDATE_REPORT_COLUMNS_REQUEST,
  UPDATE_REPORT_COLUMNS_SUCCESS,
  UPDATE_REPORT_COLUMNS_FALIURE,
  DELETE_REPORT_COLUMN_REQUEST,
  DELETE_REPORT_COLUMN_SUCCESS,
  DELETE_REPORT_COLUMN_FALIURE
} from './ReportsConstants'

const intialstate = {
  report_columns_loading : false,
  report_columns : [],
  report_columns_variables : [],
  update_report_columns : [],
  delete_report_column : '',
  report_columns_error : '',
  columnId : '',
  report_columns_success : false
}

const ReportsReducers = (state = intialstate,action) =>{
  switch(action.type){
    case REPORT_COLUMNS_LIBRARY_REQUEST : return{
      ...state,
      report_columns_loading:true,
      report_columns_error : '',
      report_columns_variables : [],
    }
    case REPORT_COLUMNS_LIBRARY_SUCCESS : return{
      ...state,
      report_columns_loading:false,
      report_columns_variables:action.payload
    }
    case REPORT_COLUMNS_LIBRARY_FALIURE : return{
      ...state,
      report_columns_loading:false,
      report_columns_error:action.payload
    }

    case REPORT_COLUMNS_REQUEST : return{
      ...state,
      report_columns_loading:true,
      report_columns_error : '',
      report_columns : null,
      update_report_columns : null,
      columnId : null
    }
    case REPORT_COLUMNS_SUCCESS : return{
      ...state,
      report_columns_loading:false,
      report_columns:action.payload
    }
    case REPORT_COLUMNS_FALIURE : return{
      ...state,
      report_columns_loading:false,
      report_columns_error:action.payload
    }

    case UPDATE_REPORT_COLUMNS_REQUEST : return{
      ...state,
      report_columns_loading:true,
      report_columns_error : '',
      update_report_columns : [],
      report_columns: null
    }
    case UPDATE_REPORT_COLUMNS_SUCCESS : return{
      ...state,
      report_columns_loading:false,
      update_report_columns:action.payload
    }
    case UPDATE_REPORT_COLUMNS_FALIURE : return{
      ...state,
      report_columns_loading:false,
      report_columns_error:action.payload
    }

    case DELETE_REPORT_COLUMN_REQUEST : return{
      ...state,
      report_columns_loading:true,
      report_columns_error : '',
      delete_report_column : '',
      report_columns: null,
    }
    case DELETE_REPORT_COLUMN_SUCCESS : return{
      ...state,
      report_columns_loading:false,
      delete_report_column:action.payload
    }
    case DELETE_REPORT_COLUMN_FALIURE : return{
      ...state,
      report_columns_loading:false,
      report_columns_error:action.payload,
      columnId: action.columnId
    }

    default: return state
  }

}

export default ReportsReducers
